import { Card, Grid, Heading, Layout } from '@enterprise-ui/canvas-ui-react'
import React from 'react'
import { SectionHeader } from '../globalComponents/SectionHeader'
import { Input, Form, Anchor } from '@design-systems/canvas-ui'
import { DatePicker } from '@enterprise-ui/canvas-ui-react-datepicker'
import { useAuth } from '@praxis/component-auth'
import { Button } from '@enterprise-ui/canvas-ui-react'
import { Modal } from '@enterprise-ui/canvas-ui-react'
import { useToaster } from '@enterprise-ui/canvas-ui-react'
import axios from 'axios'
// import { useEnv } from '@praxis/component-runtime-env'
import apiConfig from '../globalConfig/apiConfig'

export const RegularFileSubWrapper = () => {
  const auth = useAuth()
  return <RegularFileSub auth={auth} />
}

const HISTORY_TYPE_LABELS = {
  Sales: 'Sales',
  Inventory: 'Inventory',
  GrossMargin: 'Gross Margin',
}

export const RegularFileSub = ({ auth }) => {
  //const env = useEnv()
  // const API_KEY = `${env.pol_api_key}`

  const API_KEY = apiConfig.polApiKey
  const [polBackendUrl, setPolBackendUrl] = React.useState('')
  const [typeOfRequest, setTypeOfRequest] = React.useState('')
  const [existingSubscription, setExistingSubscription] = React.useState('')
  const [dataLevel, setDataLevel] = React.useState('')
  const [bpartID, setBpartID] = React.useState('')
  const [vendorName, setVendorName] = React.useState('')
  const [emailId, setEmailID] = React.useState('')
  const [partner, setPartner] = React.useState('')
  const [unsubscribe, setUnsubscribe] = React.useState('false')
  const [historyRequest, setHistoryRequest] = React.useState([])
  const [historyType, setHistoryType] = React.useState('')
  const [startDate, setStartDate] = React.useState('')
  const [endDate, setEndDate] = React.useState('')
  const [openDialog, setOpenDialog] = React.useState(false)
  const [allHistoryOpen, setAllHistoryOpen] = React.useState(false)
  const [historyExpanded, setHistoryExpanded] = React.useState(false)
  const toaster = useToaster()

  const baseTextStyle = { fontSize: '1.125rem' }

  const getHistoryTypeLabel = (type) => {
    const key = (type ?? '').toString().trim()
    return HISTORY_TYPE_LABELS[key] || key
  }

  const formatDateDisplay = (dateStr) => {
    if (!dateStr) return ''
    const d = new Date(dateStr)
    if (isNaN(d.getTime())) return dateStr
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const yyyy = d.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }

  const formatTimestampDisplay = (ts) => {
    const raw = !isNaN(Number(ts)) ? Number(ts) : ts
    const d = new Date(raw)
    if (isNaN(d.getTime())) return String(ts)
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const yyyy = d.getFullYear()
    let h = d.getHours()
    const min = String(d.getMinutes()).padStart(2, '0')
    const sec = String(d.getSeconds()).padStart(2, '0')
    const ampm = h >= 12 ? 'PM' : 'AM'
    h = h % 12 || 12
    return `${mm}/${dd}/${yyyy}, ${h}:${min}:${sec} ${ampm}`
  }

  const getHeaders = () => ({
    accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': API_KEY,
  })

  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    fetchPartnerInfo()

    const appEnv = process.env.REACT_APP_ENV

    setPolBackendUrl(
      appEnv === 'prod'
        ? 'https://api.target.com/bpd_pol/v1'
        : 'https://stage-api.target.com/bpd_pol/v1',
    )
  }, [])

  React.useEffect(() => {
    if (!polBackendUrl || !bpartID) return

    getBusinessPartnerInfo()
    getExistingSubscription()
    getExistingHistorySubscription(true)
  }, [polBackendUrl, bpartID])
  /* eslint-enable react-hooks/exhaustive-deps */

  const fetchPartnerInfo = () => {
    setBpartID(auth.session.userInfo.lanId)
    setVendorName(auth.session.userInfo.fullName)
    setEmailID(auth.session.userInfo.email)
  }

  const getBusinessPartnerInfo = () => {
    const bpartOptions = {
      method: 'GET',
      url: `${polBackendUrl}/business-partner/user/${bpartID}`,
      headers: getHeaders(),
    }

    axios
      .request(bpartOptions)
      .then((response) => {
        if (response.status === 404) {
          setPartner('')
        } else {
          setPartner(response.data.partner)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const getExistingSubscription = async () => {
    try {
      const subOptions = {
        method: 'GET',
        url: `${polBackendUrl}/subscription/user/${encodeURIComponent(bpartID)}`,
        headers: getHeaders(),
      }

      const response = await axios.request(subOptions)

      const reportId = response.data?.report_id ?? ''
      setDataLevel(reportId)
      setExistingSubscription(reportId)
      return response
    } catch (err) {
      if (err.response?.status === 404) {
        setDataLevel('')
        setExistingSubscription('')
        return null
      }
      return
    }
  }

  const getExistingHistorySubscription = async (forceRefresh = false) => {
    try {
      const cacheBuster = forceRefresh ? `&_=${Date.now()}` : ''
      const url = `${polBackendUrl}/history/requests?bpart_user_ref_i=${encodeURIComponent(bpartID)}${cacheBuster}`

      const res = await axios.get(url, {
        headers: getHeaders(),
      })

      console.log('History subscription found', res.data)
      setHistoryRequest(res.data || [])
    } catch (error) {
      if (
        error.response?.status === 404 &&
        error.response?.data?.message ===
          'Partner not found for user: ' + bpartID
      ) {
        console.log('No partner found for user')
        setHistoryRequest([])
        return
      }
      console.error('Error:', error)
    }
  }

  const postRegularSubscription = async () => {
    const regularRequestBody = {
      bpart_user_ref_i: bpartID,
      email: emailId,
      report_id: dataLevel,
    }

    const subOptions = {
      method: 'POST',
      url: `${polBackendUrl}/subscription/user`,
      headers: getHeaders(),
      data: regularRequestBody,
    }

    await axios
      .request(subOptions)
      .then((response) => {
        console.log(response.data)
        setOpenDialog(true)
      })
      .catch((error) => {
        console.error(error)
        if (
          error.response?.status === 404 &&
          error.response?.data?.message?.includes('Partner not found')
        ) {
          toaster({
            type: 'error',
            heading: 'Partner Not Found',
            message:
              'Your account is not associated with a registered business partner. Please contact support.',
          })
        } else if (
          error.response?.status === 401 ||
          error.response?.status === 403
        ) {
          toaster({
            type: 'error',
            heading: 'Authentication Error',
            message:
              'Your session may have expired. Please log out and log back in.',
          })
        } else {
          toaster({
            type: 'error',
            heading: 'Something went wrong!',
            message: error.response?.data?.message || 'Please try again later.',
          })
        }
      })
  }

  const postHistorySubscription = () => {
    const formattedStartDate = new Date(startDate).toLocaleDateString('en-CA')
    const formattedEndDate = new Date(endDate).toLocaleDateString('en-CA')

    const historyRequestBody = {
      bpart_user_ref_i: bpartID,
      partner: '100',
      hist_type: historyType,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      submit_ts: `${localDateTime()}`,
      hist_processed: 'O',
    }

    const subOptions = {
      method: 'POST',
      url: `${polBackendUrl}/history/requests`,
      headers: getHeaders(),
      data: historyRequestBody,
    }

    axios
      .request(subOptions)
      .then((response) => {
        console.log(response.data)
        setOpenDialog(true)
        getExistingHistorySubscription(true)
      })
      .catch((error) => {
        console.error(error)
        if (
          error.response?.data?.message ===
          'History request already exists for partner/date range/type'
        ) {
          toaster({
            type: 'error',
            heading: 'Conflict!',
            message:
              'History request already exists for partner/date range/type.',
          })
        } else if (
          error.response?.status === 404 &&
          error.response?.data?.message ===
            'Partner not found for user: ' + bpartID
        ) {
          toaster({
            type: 'error',
            heading: 'Error!',
            message: 'Partner number not found for user: ' + bpartID,
          })
        } else {
          toaster({
            type: 'error',
            heading: 'Something went wrong!',
            message: 'Please try again later.',
          })
        }
      })
  }

  const deleteRegularSubscription = async () => {
    try {
      const subOptions = {
        method: 'DELETE',
        url: `${polBackendUrl}/subscription/user/${bpartID}`,
        headers: getHeaders(),
      }

      await axios.request(subOptions)
      await getExistingSubscription()
    } catch (error) {
      console.error(error)
      toaster({
        type: 'error',
        heading: 'Something went wrong!',
        message: 'Please try again later',
      })
      await handleRegularCancel()
    }
  }

  const deleteHistoryRequest = async (
    bpart_user_ref_i,
    hist_type,
    start_date,
    end_date,
  ) => {
    // Only allow deletion if the request belongs to the current user
    if (bpart_user_ref_i?.trim() !== bpartID?.trim()) {
      toaster({
        type: 'error',
        heading: 'Unauthorized',
        message: 'You can only delete history requests submitted by you.',
      })
      return
    }

    try {
      const body = {
        bpart_user_ref_i: bpart_user_ref_i?.trim(),
        hist_type,
        start_date,
        end_date,
      }

      setHistoryRequest((prev) =>
        (prev || []).filter(
          (r) =>
            !(
              r.bpart_user_ref_i === body.bpart_user_ref_i &&
              r.hist_type === body.hist_type &&
              r.start_date === body.start_date &&
              r.end_date === body.end_date
            ),
        ),
      )

      const deleteRes = await axios.delete(
        `${polBackendUrl}/history/requests`,
        {
          headers: getHeaders(),
          data: body,
        },
      )

      if (deleteRes.status >= 200 && deleteRes.status < 300) {
        toaster({
          type: 'success',
          heading: 'Deleted!',
          message: `History request for ${getHistoryTypeLabel(hist_type)} (${formatDateDisplay(start_date)} — ${formatDateDisplay(end_date)}) has been deleted.`,
        })
        await getExistingHistorySubscription(true)
      } else {
        console.error('Unexpected delete response:', deleteRes)
        await getExistingHistorySubscription(true)
      }
    } catch (err) {
      console.error('Delete failed:', err)
      toaster({
        type: 'error',
        heading: 'Something went wrong!',
        message: 'Please try again later.',
      })
      await getExistingHistorySubscription(true)
    }
  }

  const handleRegularSubmit = async () => {
    if (unsubscribe === 'true') {
      await deleteRegularSubscription()
      setOpenDialog(true)
    } else {
      await postRegularSubscription()
    }
  }

  const handleRegularCancel = async () => {
    await getExistingSubscription()
    setUnsubscribe('false')
    setTypeOfRequest('')
  }

  const handleHistoryCancel = () => {
    setHistoryType('')
    setStartDate('')
    setEndDate('')
    setTypeOfRequest('')
  }

  const handleModalDone = async () => {
    setOpenDialog(false)
    setDataLevel('')
    setUnsubscribe('false')
    setTypeOfRequest('')
    setHistoryType('')
    setStartDate('')
    setEndDate('')
    await getExistingSubscription()
    await getExistingHistorySubscription(true)
  }

  //Timestamp for histroy request
  function localDateTime() {
    const d = new Date()

    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')

    const HH = String(d.getHours()).padStart(2, '0')
    const MM = String(d.getMinutes()).padStart(2, '0')
    const SS = String(d.getSeconds()).padStart(2, '0')
    const mmm = String(d.getMilliseconds()).padStart(3, '0')

    return `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}.${mmm}`
  }

  const handleRegularValidation = () => {
    // Validate data level selection (skip if unsubscribing)
    if (typeOfRequest === 'regular' && !dataLevel && unsubscribe !== 'true') {
      toaster({
        type: 'error',
        heading: 'Missing selection',
        message:
          'Please select a data subscription level before submitting the form.',
      })
      return
    }

    // No change from current subscription
    if (
      unsubscribe !== 'true' &&
      existingSubscription !== '' &&
      dataLevel === existingSubscription
    ) {
      toaster({
        type: 'error',
        heading: 'No changes detected',
        message:
          'Your selection is the same as your current subscription. Please choose a different option or unsubscribe.',
      })
      return
    }

    Promise.resolve(handleRegularSubmit())
  }

  const handleHistoryValidation = () => {
    if (typeOfRequest === 'history') {
      //Validate history type selection
      if (historyType === '') {
        toaster({
          type: 'error',
          heading: 'Missing History Type',
          message:
            'Please select a history subscription type before submitting the form.',
        })
        return
      }
      //Validate start and end date selection
      if (!(new Date(startDate) < new Date(endDate))) {
        toaster({
          type: 'error',
          heading: 'Date Selection Error',
          message:
            'Please ensure start date is before end date before submitting the form.',
        })
        return
      }
      //Validate number of requests per day per user
      const dailyCutoffMs = Date.now() - 24 * 60 * 60 * 1000
      const recentRequests = (historyRequest || []).filter((request) => {
        // Only count requests submitted by the current user
        if (request.bpart_user_ref_i?.trim() !== bpartID?.trim()) return false
        const ts = !isNaN(Number(request.submit_ts))
          ? Number(request.submit_ts)
          : new Date(request.submit_ts).getTime()
        // Only count non-tombstone requests submitted in last 24h
        return ts >= dailyCutoffMs
      })
      if (recentRequests.length >= 3) {
        toaster({
          type: 'error',
          heading: 'History Selection Error',
          message:
            'You have reached the maximum number of history file requests for today. Please try again tomorrow.',
        })
        return
      }
    }

    Promise.resolve(postHistorySubscription())
  }

  function getSundays(start, end) {
    const sundays = []
    const d = new Date(start)

    // move to first Sunday
    d.setDate(d.getDate() + ((7 - d.getDay()) % 7))

    while (d <= end) {
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      const yyyy = d.getFullYear()
      sundays.push(`${mm}/${dd}/${yyyy}`)
      d.setDate(d.getDate() + 7)
    }

    return sundays
  }

  function getSaturdays(start, end) {
    const saturdays = []
    const d = new Date(start)

    // move to first Saturday
    d.setDate(d.getDate() + ((6 - d.getDay() + 7) % 7))

    while (d <= end) {
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      const yyyy = d.getFullYear()
      saturdays.push(`${mm}/${dd}/${yyyy}`)
      d.setDate(d.getDate() + 7)
    }

    return saturdays
  }

  const today = new Date()
  // Allow dates up to last completed week's Saturday (exclude current week)
  const resultDate = new Date(today)
  const daysSinceSaturday = (today.getDay() + 1) % 7 || 7
  resultDate.setDate(today.getDate() - daysSinceSaturday)

  const lastPossibleDate = new Date()
  lastPossibleDate.setFullYear(lastPossibleDate.getFullYear() - 2)

  const allowedSundays = getSundays(lastPossibleDate, resultDate)
  const allowedSaturdays = getSaturdays(lastPossibleDate, resultDate)

  const startYear = lastPossibleDate.getFullYear()
  const endYear = resultDate.getFullYear()

  const tombstoneCutoffMs = Date.now() - 60 * 24 * 60 * 60 * 1000 // 60 days

  const getTimestamp = (submit_ts) => {
    return !isNaN(Number(submit_ts))
      ? Number(submit_ts)
      : new Date(submit_ts).getTime()
  }

  // Returns true if the request was submitted before today's 1:45 AM CST6CDT
  // (i.e. backend job has picked it up for processing)
  const isProcessing = (request) => {
    const ts = getTimestamp(request.submit_ts)
    // Build today's 1:45 AM in CST6CDT (America/Chicago)
    const nowInCST = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }),
    )
    const cutoff = new Date(nowInCST)
    cutoff.setHours(1, 45, 0, 0)
    // Convert cutoff back to UTC for comparison
    const cutoffUTC = new Date(
      cutoff.toLocaleString('en-US', { timeZone: 'America/Chicago' }),
    )
    // If current CST time is before 1:45 AM, use yesterday's 1:45 AM
    if (nowInCST < cutoff) {
      cutoffUTC.setDate(cutoffUTC.getDate() - 1)
    }
    return ts < cutoffUTC.getTime()
  }

  // Unprocessed: flag N, within 60 days
  const filteredRequests = (historyRequest || [])
    .filter((request) => {
      if (request.hist_processed !== 'N') return false
      const ts = getTimestamp(request.submit_ts)
      return ts >= tombstoneCutoffMs
    })
    .sort((a, b) => getTimestamp(b.submit_ts) - getTimestamp(a.submit_ts))

  // Processed: flag Y, within 60 days
  const allProcessedRequests = (historyRequest || [])
    .filter((request) => {
      if (request.hist_processed !== 'Y') return false
      const ts = getTimestamp(request.submit_ts)
      return ts >= tombstoneCutoffMs
    })
    .sort((a, b) => getTimestamp(b.submit_ts) - getTimestamp(a.submit_ts))

  return (
    <>
      <SectionHeader pageHeading="Business Partner Data Subscription Form" />
      <Layout.Body data-testid="homePage" includeRail>
        <Card className="hc-pa-normal parent-container">
          {/* Introduction Section */}
          <div className="child-container">
            <Grid.Container justify="center" style={{ textAlign: 'center' }}>
              <Grid.Item xs={12} style={{ textAlign: 'center' }}>
                <p style={baseTextStyle}>
                  This form can be used to sign up for or view/modify existing
                  bulk data subscriptions.
                  <br />
                  <strong>Note:</strong> Category captains must email
                  Category.Management@target.com for access or modifications to
                  their Business Partner Data subscription.
                </p>
              </Grid.Item>
            </Grid.Container>
          </div>

          {/* User Contact Info Section */}
          <div className="child-container">
            <Grid.Container justify="center">
              <Grid.Item
                xs={12}
                style={{ marginBottom: '1rem', textAlign: 'center' }}
              >
                <Heading size={4}>User Contact Info</Heading>
              </Grid.Item>
            </Grid.Container>

            <Grid.Container justify="center">
              <Grid.Item xs={3}>
                <p style={{ textAlign: 'center', ...baseTextStyle }}>
                  {bpartID}
                </p>
              </Grid.Item>
              <Grid.Item xs={3}>
                <p style={{ textAlign: 'center', ...baseTextStyle }}>
                  {vendorName}
                </p>
              </Grid.Item>
              <Grid.Item xs={3}>
                <p style={{ textAlign: 'center', ...baseTextStyle }}>
                  {emailId}
                </p>
              </Grid.Item>
              <Grid.Item xs={3}>
                <p style={{ textAlign: 'center', ...baseTextStyle }}>
                  {partner}
                </p>
              </Grid.Item>
              <Grid.Item xs={12}>
                <p
                  style={{
                    paddingTop: '0.5rem',
                    textAlign: 'center',
                    ...baseTextStyle,
                  }}
                >
                  Please logout from this session before subscribing for the
                  next business partner.
                </p>
              </Grid.Item>
            </Grid.Container>
          </div>

          {/* Request Type Selection Section */}
          <div className="child-container">
            <Grid.Container justify="center">
              {partner && (
                <Grid.Item
                  xs={12}
                  style={{ textAlign: 'center', marginBottom: '0.5rem' }}
                >
                  <p className="highlight-note">
                    <strong>Note:</strong> History Files can only be requested
                    if you have selected Regular Files request at Item/Location
                    level
                  </p>
                </Grid.Item>
              )}
              {!partner ? (
                <Grid.Item
                  xs={12}
                  style={{ textAlign: 'center', marginBottom: '0.5rem' }}
                >
                  <p className="highlight-note" style={{ color: '#cc0000' }}>
                    <strong>Error:</strong> Your account is not associated with
                    a registered business partner. Please contact support.
                  </p>
                </Grid.Item>
              ) : (
                <Grid.Item
                  xs={6}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Input.Radios
                    value={typeOfRequest}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '2rem',
                      alignItems: 'center',
                      fontSize: '1.125rem',
                    }}
                    options={[
                      {
                        id: 'regular',
                        key: 'regular',
                        value: 'regular',
                        label: 'Regular Files Request',
                      },
                      ...(existingSubscription === 3
                        ? [
                            {
                              id: 'history',
                              key: 'history',
                              value: 'history',
                              label: 'History Files Request',
                            },
                          ]
                        : []),
                    ]}
                    onChange={(e) => setTypeOfRequest(e.target.value)}
                  />
                </Grid.Item>
              )}
            </Grid.Container>
          </div>

          {(typeOfRequest === 'regular' || typeOfRequest === 'history') && (
            <div className="child-container">
              {typeOfRequest === 'regular' && (
                <>
                  <Form
                    id="regular-request-form"
                    onSubmit={(e) => {
                      e.preventDefault()
                      handleRegularValidation()
                    }}
                  >
                    <Grid.Container
                      justify="center"
                      style={{ marginBottom: '1rem' }}
                    >
                      <Grid.Item
                        xs={12}
                        style={{ marginBottom: '1rem', textAlign: 'center' }}
                      >
                        <Heading size={5}>DATA SUBSCRIPTION</Heading>
                        <p style={baseTextStyle}>
                          Choose from the following options to sign up for
                          Business Partner Data Subscription;
                          <br />
                          You can also use this to modify your existing
                          subscription. If you have existing subscription, your
                          selections are highlighted below.
                        </p>
                      </Grid.Item>
                      <Grid.Item
                        xs={12}
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Input.Radios
                          value={dataLevel}
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '5rem',
                            alignItems: 'flex-start',
                            fontSize: '1.125rem',
                          }}
                          options={[
                            {
                              id: 'item',
                              key: 'item',
                              value: Number('4'),
                              label: (
                                <div
                                  className={
                                    existingSubscription === 4
                                      ? 'selected-option'
                                      : 'option-container'
                                  }
                                  style={{ paddingLeft: '0.5rem' }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: '1.125rem',
                                    }}
                                  >
                                    Item Level Data
                                    {existingSubscription === 4 && (
                                      <span
                                        style={{
                                          marginLeft: '0.5rem',
                                          fontSize: '0.875rem',
                                          color: 'green',
                                        }}
                                      >
                                        (Current)
                                      </span>
                                    )}
                                  </div>
                                  <ul
                                    style={{ margin: 0, paddingLeft: '1.5rem' }}
                                  >
                                    <li key="weekly-sales">Weekly Sales</li>
                                    <li key="weekly-inventory">
                                      Weekly Inventory
                                    </li>
                                    <li key="item-attribute">Item Attribute</li>
                                    <li key="gross-margin">Gross Margin</li>
                                  </ul>
                                </div>
                              ),
                            },
                            {
                              id: 'item-loc',
                              key: 'item-loc',
                              value: Number('3'),
                              label: (
                                <div
                                  className={
                                    existingSubscription === 3
                                      ? 'selected-option'
                                      : 'option-container'
                                  }
                                  style={{ paddingLeft: '0.5rem' }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: '1.125rem',
                                    }}
                                  >
                                    Item/Location Level Data
                                    {existingSubscription === 3 && (
                                      <span
                                        style={{
                                          marginLeft: '0.5rem',
                                          fontSize: '0.875rem',
                                          color: 'green',
                                        }}
                                      >
                                        (Current)
                                      </span>
                                    )}
                                  </div>
                                  <ul
                                    style={{ margin: 0, paddingLeft: '1.5rem' }}
                                  >
                                    <li key="weekly-sales-daily-sales">
                                      Weekly Sales / Daily Sales
                                    </li>
                                    <li key="weekly-inventory-daily-inventory">
                                      Weekly Inventory / Daily Inventory
                                    </li>
                                    <li key="gross-margin">
                                      Weekly Gross Margin
                                    </li>
                                    <li key="history">
                                      History Sales / Inventory / Gross Margin
                                    </li>
                                    <li key="item-attribute-location-attribute">
                                      Item Attribute / Location Attribute
                                    </li>
                                  </ul>
                                </div>
                              ),
                            },
                          ]}
                          onChange={(e) => {
                            setDataLevel(Number(e.target.value))
                            setUnsubscribe('false')
                          }}
                        />
                      </Grid.Item>
                      {existingSubscription !== '' && (
                        <Grid.Item>
                          <Input.Radios
                            value={unsubscribe}
                            className="option-container-unsubscribe"
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              gap: '5rem',
                              alignItems: 'flex-start',
                              fontSize: '1.125rem',
                            }}
                            options={[
                              {
                                id: 'unsubscribe',
                                key: 'unsubscribe',
                                value: 'true',
                                label: 'Unsubscribe',
                              },
                            ]}
                            onChange={(e) => {
                              const val = e.target.value
                              if (unsubscribe === val) {
                                setUnsubscribe('false')
                                setDataLevel(existingSubscription)
                              } else {
                                setUnsubscribe(val)
                                setDataLevel('')
                              }
                            }}
                          />
                        </Grid.Item>
                      )}
                      <Grid.Item xs={12} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '1rem',
                          }}
                        >
                          <Button type="submit" className="submit-button">
                            Submit
                          </Button>
                          <Button
                            type="secondary"
                            className="submit-button"
                            onClick={handleRegularCancel}
                          >
                            Cancel
                          </Button>
                        </div>
                      </Grid.Item>
                    </Grid.Container>
                  </Form>
                </>
              )}

              {typeOfRequest === 'history' && (
                <Form
                  id="history-request-form"
                  onSubmit={(e) => {
                    e.preventDefault()
                    handleHistoryValidation()
                  }}
                >
                  <Grid.Container>
                    <Grid.Item xs={12}>
                      <div className="history-panel">
                        <div className="history-panel-header">
                          <span className="history-panel-title">
                            Previously submitted History File requests
                          </span>
                          <Anchor
                            className="history-link"
                            onClick={() => setAllHistoryOpen(true)}
                          >
                            View processed history requests
                          </Anchor>
                        </div>

                        {filteredRequests.length > 0 ? (
                          <div className="history-list">
                            {(filteredRequests.length > 3 && !historyExpanded
                              ? filteredRequests.slice(0, 3)
                              : filteredRequests
                            ).map((request, index) => (
                              <div
                                className="history-item"
                                key={`${request.hist_type}-${request.start_date}-${request.end_date}`}
                              >
                                <div className="history-item-info">
                                  <span className="history-item-number">
                                    {index + 1}
                                  </span>
                                  <div className="history-item-details">
                                    <span className="history-item-type">
                                      {getHistoryTypeLabel(request.hist_type)}
                                    </span>
                                    <span className="history-item-dates">
                                      {formatDateDisplay(request.start_date)}{' '}
                                      &mdash;{' '}
                                      {formatDateDisplay(request.end_date)}
                                    </span>
                                    {request.submit_ts && (
                                      <span className="history-item-submitted">
                                        Submitted by:{' '}
                                        <strong>
                                          {request.bpart_user_ref_i?.trim()}
                                        </strong>{' '}
                                        On{' '}
                                        {formatTimestampDisplay(
                                          request.submit_ts,
                                        )}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="history-item-actions">
                                  {isProcessing(request) ? (
                                    <span className="tag tag--processing">
                                      Processing
                                    </span>
                                  ) : (
                                    <>
                                      <span className="tag tag--unprocessed">
                                        Submitted
                                      </span>
                                      <Button
                                        type="destructive"
                                        size="dense"
                                        onClick={() =>
                                          deleteHistoryRequest(
                                            request.bpart_user_ref_i,
                                            request.hist_type,
                                            request.start_date,
                                            request.end_date,
                                          )
                                        }
                                      >
                                        Delete
                                      </Button>
                                    </>
                                  )}
                                </div>
                              </div>
                            ))}
                            {filteredRequests.length > 3 && (
                              <div
                                className="history-toggle"
                                onClick={() =>
                                  setHistoryExpanded(!historyExpanded)
                                }
                              >
                                {historyExpanded
                                  ? 'Show less'
                                  : `Show all ${filteredRequests.length} requests`}
                              </div>
                            )}
                          </div>
                        ) : (
                          <p className="history-empty">
                            No existing history subscriptions found.
                          </p>
                        )}
                      </div>
                    </Grid.Item>
                  </Grid.Container>
                  <br />
                  <Grid.Container
                    spacing="lg"
                    style={{
                      ...baseTextStyle,
                      marginBottom: '1rem',
                      marginLeft: '1rem',
                    }}
                  >
                    {/* Existing History Section */}

                    <Grid.Item
                      xs={12}
                      style={{ textAlign: 'center', marginBottom: '1rem' }}
                    >
                      <p style={{ fontSize: '1.125rem' }}>
                        Select the below checkboxes to generate historical files
                        for the below categories. All files will be generated at{' '}
                        <b style={{ fontWeight: 700 }}>Weekly Item-Location</b>{' '}
                        grain.
                      </p>
                    </Grid.Item>
                    <Grid.Item
                      xs={12}
                      style={{
                        marginTop: '1rem',
                        marginBottom: '1rem',
                        textAlign: 'center',
                      }}
                    >
                      <Input.Radios
                        required
                        value={historyType}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '2rem',
                          justifyContent: 'center',
                          fontSize: '1.125rem',
                        }}
                        options={[
                          {
                            id: 'sales',
                            key: 'sales',
                            value: 'Sales',
                            label: 'Sales',
                          },
                          {
                            id: 'inventory',
                            key: 'inventory',
                            value: 'Inventory',
                            label: 'Inventory',
                          },
                          {
                            id: 'grossmargin',
                            key: 'grossmargin',
                            value: 'GrossMargin',
                            label: 'Gross Margin',
                          },
                        ]}
                        onChange={(e) => setHistoryType(e.target.value)}
                      />
                    </Grid.Item>
                    <Grid.Item
                      xs={6}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        paddingRight: '1rem',
                      }}
                    >
                      <div style={{ width: '250px' }}>
                        <DatePicker
                          id="startDate"
                          required
                          yearRange={{ startYear, endYear }}
                          label={
                            <span style={{ fontSize: '1.125rem' }}>
                              Start Date
                            </span>
                          }
                          inputprops={{ readOnly: true, 'aria-readonly': true }}
                          disableDates={{
                            except: allowedSundays,
                          }}
                          onUpdate={(id, value) => {
                            setStartDate(value)
                          }}
                        />
                      </div>
                    </Grid.Item>
                    <Grid.Item
                      xs={6}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        paddingLeft: '1rem',
                      }}
                    >
                      <div style={{ width: '250px' }}>
                        <DatePicker
                          required
                          id="endDate"
                          yearRange={{ startYear, endYear }}
                          label={
                            <span style={{ fontSize: '1.125rem' }}>
                              End Date
                            </span>
                          }
                          inputprops={{ readOnly: true, 'aria-readonly': true }}
                          disableDates={{
                            except: allowedSaturdays,
                          }}
                          onUpdate={(id, value) => {
                            setEndDate(value)
                          }}
                        />
                      </div>
                    </Grid.Item>
                    <Grid.Item
                      xs={12}
                      style={{ textAlign: 'center', marginTop: '1rem' }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '1rem',
                        }}
                      >
                        <Button type="submit" className="submit-button">
                          Submit
                        </Button>
                        <Button
                          type="secondary"
                          className="submit-button"
                          onClick={handleHistoryCancel}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Grid.Item>
                  </Grid.Container>
                </Form>
              )}
            </div>
          )}
        </Card>
        {openDialog && (
          <Card>
            <Grid.Container justify="center">
              <Modal
                style={{ ...baseTextStyle, textAlign: 'center' }}
                isVisible={openDialog}
                headingText="Subscription Confirmation"
                onApprove={() => setOpenDialog(false)}
                onRefuse={() => setOpenDialog(false)}
              >
                <div
                  className="success-message"
                  style={{ textAlign: 'center' }}
                >
                  Your Request has been successfully submitted.
                  <br />
                  Please allow up to 2 days for the updates to take effect.
                  <br />
                  {typeOfRequest === 'regular' && (
                    <>
                      <br />
                      <strong>Subscription:</strong>
                      <br />
                      {dataLevel === Number('4') && <>Item Level Data</>}
                      {dataLevel === Number('3') && (
                        <>Item/Location Level Data</>
                      )}
                      {unsubscribe === 'true' && <> Unsubscribed</>}
                    </>
                  )}
                  {typeOfRequest === 'history' && (
                    <>
                      <br />
                      <strong>History Subscription:</strong>
                      <br />
                      History File Selection :{' '}
                      {getHistoryTypeLabel(historyType)}, Start Date:{' '}
                      {formatDateDisplay(startDate)}, End Date:{' '}
                      {formatDateDisplay(endDate)}
                    </>
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '1.5rem',
                    marginBottom: '1.5rem',
                  }}
                >
                  <Button
                    type="primary"
                    className="submit-button"
                    onClick={() => handleModalDone()}
                  >
                    Done
                  </Button>
                </div>
              </Modal>
            </Grid.Container>
          </Card>
        )}
        {allHistoryOpen && (
          <Card>
            <Grid.Container justify="center">
              <Modal
                style={{ ...baseTextStyle, textAlign: 'center' }}
                isVisible={allHistoryOpen}
                headingText="Processed History Request(s)"
                onApprove={() => setAllHistoryOpen(false)}
                onRefuse={() => setAllHistoryOpen(false)}
              >
                <div style={{ textAlign: 'left', margin: '1rem' }}>
                  {allProcessedRequests.length === 0 ? (
                    <p className="history-empty">
                      No processed history requests found.
                    </p>
                  ) : (
                    <div className="history-list">
                      {allProcessedRequests.map((request, index) => (
                        <div
                          className="history-item history-item--processed"
                          key={`${request.hist_type}-${request.start_date}-${request.end_date}`}
                        >
                          <div className="history-item-info">
                            <span className="history-item-number history-item-number--processed">
                              {index + 1}
                            </span>
                            <div className="history-item-details">
                              <span className="history-item-type">
                                {getHistoryTypeLabel(request.hist_type)}
                              </span>
                              <span className="history-item-dates">
                                {formatDateDisplay(request.start_date)} &mdash;{' '}
                                {formatDateDisplay(request.end_date)}
                              </span>
                              {request.submit_ts && (
                                <span className="history-item-submitted">
                                  Submitted:{' '}
                                  {formatTimestampDisplay(request.submit_ts)} by{' '}
                                  <strong>
                                    {request.bpart_user_ref_i?.trim()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </div>
                          <span className="tag tag--processed">Processed</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Modal>
            </Grid.Container>
          </Card>
        )}
      </Layout.Body>
    </>
  )
}
